import { SegmentCategory } from './segmentcategory';
import { SegmentSubCategory } from './segmentsubcategory';

export const menu = {
	name: 'CorporateSegment',
	list: [
		{ name: 'SegmentCategory', route: SegmentCategory.name },
		{ name: 'SegmentSubCategory', route: SegmentSubCategory.name },
	],
};
